export const getResourcePageType = (type: string | null | undefined): string => {
	if (!type) return 'reports'
	if (['Webinar', 'Webinar TY'].includes(type)) return 'webinars'
	if (['Guide', 'Guide TY'].includes(type)) return 'guides'
	return 'reports'
}
